import { render, staticRenderFns } from "./JournalEntryList.vue?vue&type=template&id=06c715e4"
import script from "./JournalEntryList.vue?vue&type=script&lang=js"
export * from "./JournalEntryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports